import 'alpinejs';

require('../bootstrap');
require('../plugins');

